
    // import axios from 'axios';
   
    import React, { Suspense } from "react";
    import { Canvas } from  "@react-three/fiber";//"react-three-fiber";
    import { OrbitControls, useGLTF } from "@react-three/drei";
    import { useState, useEffect} from "react";
    import { getUserMarketNftsLiveById } from "../../utils/wallet"
    
    const Model = (glbPath) => {
      console.log(glbPath.glbPath)
      const { scene } = useGLTF(glbPath.glbPath);
      return <primitive object={scene} />;
    }
    
    const Card = (props) => {
        // const { item } = props;
        //console.log(props);
        
        const name = props.itemData.name;
        const description = props.itemData.description;
        const glbPath = props.itemData.glbPath;
        //const url = '/tim.jpg';

        // const { name, description, glbPath } = props;
        console.log('description',description);
        console.log('glbPath',glbPath);
        
        return (
            <div className="col">
                <div className="card h-600">
                    {/* <img src={props.img} className="card-img-top" alt="..." /> */}
                    {/* <Canvas pixelRatio={[1, 2]} camera={{ position: [-1, 1, 1], fov: 50 }}>
                            <ambientLight intensity={1} />
                                <Suspense fallback={null}>
                                    <Model glbPath={glbPath}/>
                                </Suspense>
                            <OrbitControls />
                        </Canvas> */}



                        <Canvas shadows camera={{ position: [-5, 20, 10], fov: 60 }} style={{height: '450px'}}>
    <fog attach="fog" args={["white", 0, 40]} />
    <ambientLight intensity={0.4} />
    <directionalLight
      castShadow
      position={[2.5, 8, 5]}
      intensity={0.5}
      shadow-mapSize-width={1024}
      shadow-mapSize-height={1024}
      shadow-camera-far={50}
      shadow-camera-left={-10}
      shadow-camera-right={10}
      shadow-camera-top={10}
      shadow-camera-bottom={-10}
    />
    <pointLight position={[-10, 0, -20]} color="#FFFFFF" intensity={2.5} />
    <pointLight position={[0, -10, 0]} intensity={1.5} />
    <group position={[0, -3.5, 0]}>
    <Suspense fallback={null}>
                                    <Model glbPath={glbPath}/>
                                </Suspense>
      {/* <mesh receiveShadow castShadow>
        <boxBufferGeometry attach="geometry" args={[4, 1, 1]} />
        <meshStandardMaterial attach="material" />
      </mesh>
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, -0.5, 0]} receiveShadow>
        <planeBufferGeometry attach="geometry" args={[100, 100]} />
        <shadowMaterial attach="material" transparent opacity={0.4} />
      </mesh> */}
    
    </group>
    <OrbitControls />
  </Canvas>

                    <div className="card-body">
                        <h5 className="card-title">{name}</h5>
                        <p className="card-text">{description}</p>
                        
                    </div>
                </div>
            </div>
        );
    };
    
    const GalleryItem = ({ itemId }) => {
        const [loading, setLoading] = useState(true);
        const [item, setItem] = useState({
            name: 'Loading...',
            description: 'Loading...',
            glbPath: '',
            url: ''
        });

        useEffect(() => {
            const func = async () => {
                const props = await getUserMarketNftsLiveById(itemId);
                console.log(props);
                setItem(props);
                setLoading(false);
            }
            func();
        }, [itemId]);
        return (
            <div>
                <div className="row row-cols-1 row-cols-md-3 g-4" style={{background:'black'}}>
                {loading  ? <div style={{width:'100%', height:'2000px', background:'transparent'}}>
                    <div className='centerLoader'>
                    <span className="spinner-border spinner-border-lg" role="status" aria-hidden="true"></span>
                    </div>
                    </div>
                    :<>
                    <div className="row row-cols-1 row-cols-md-3 g-4"  style={{background:'black',marginTop:'260px',width:'100%'}}>
                    <Card itemData={item} />
                    </div>
                    </>}
                </div>
            </div>
           
        );
    };
    
    export default GalleryItem;
    